import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../../../core/services/modal.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-id-not-registerd-info',
  standalone: true,
  imports: [TranslateModule],
  providers: [],
  templateUrl: './id-not-registerd-info.component.html',
  styleUrl: './id-not-registerd-info.component.scss'
})
export class IdNotRegisterdInfoComponent {
  constructor(
    public activeModal: NgbActiveModal,
    public modalService: ModalService,
    public translateService: TranslateService
  ) { }
  openUrl() {
    window.open(this.translateService.currentLang === 'ar' ? 'https://hawyti.paci.gov.kw/Arabic/Home_ar.aspx' : 'https://hawyti.paci.gov.kw/English/Home.aspx', '_blank');
  }
}
